import { Component, inject } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import {
  ProvidersService,
  StoreProviderRequestData,
} from "@services/providers.service";
import { take } from "rxjs";

@Component({
  selector: "app-provider-dialog",
  templateUrl: "./provider-dialog.component.html",
  styleUrls: ["./provider-dialog.component.scss"],
})
export class ProviderDialogComponent {
  dialogRef = inject(MatDialogRef<ProviderDialogComponent>);
  providerService = inject(ProvidersService);

  providerForm = new FormGroup({
    company_name: new FormControl("", [
      Validators.required,
      Validators.maxLength(191),
    ]),
    user: new FormGroup({
      first_name: new FormControl("", [
        Validators.required,
        Validators.maxLength(128),
      ]),
      last_name: new FormControl("", [
        Validators.required,
        Validators.maxLength(128),
      ]),
      email: new FormControl("", [
        Validators.required,
        Validators.email,
        Validators.maxLength(128),
      ]),
      phone_number: new FormControl("", [
        Validators.required,
        Validators.maxLength(128),
      ]),
      phone_prefix: new FormControl("", [
        Validators.required,
        Validators.maxLength(128),
      ]),
      company_position: new FormControl("", [Validators.maxLength(128)]), // Optional field
    }),
  });

  constructor() {}

  submit(): void {
    this.providerForm.markAllAsTouched(); // Mark all fields as touched to show validation errors
    if (this.providerForm.invalid) {
      return;
    }
    const formData = this.providerForm.value as StoreProviderRequestData;

    this.providerService
      .storeProvider(formData)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.dialogRef.close({
            provider: response,
          }); // Close the dialog on successful submission
        },
        error: (error) => {
          console.error("Error saving provider:", error);
          // Handle error appropriately, e.g., show an alert
        },
      });
  }
}
